import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { advanceRun, getRun } from "@/api/runs";
import { IN_FLIGHT_STATUSES, type RunRead } from "@/api/create-types";

/** Polls a run every 3s while it is in-flight (mirrors iOS ActiveRunsStore's
 *  3-second cadence) and exposes the advance mutation for awaiting_user steps. */
export function useRun(runId: string) {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ["run", runId],
    queryFn: () => getRun(runId),
    enabled: !!runId,
    refetchInterval: (q) => {
      const data = q.state.data as RunRead | undefined;
      return data && IN_FLIGHT_STATUSES.includes(data.status) ? 3000 : false;
    },
  });

  const advance = useMutation({
    mutationFn: (userResponse: Record<string, unknown>) => advanceRun(runId, userResponse),
    onSuccess: (run) => qc.setQueryData(["run", runId], run),
  });

  return { query, advance };
}
